


let resize = function(Vue){
// 设置 rem 函数
    function setRem () {
        // 320 默认大小16px; 320px = 20rem ;每个元素px基础上/16
        let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
        if(htmlWidth<768){
            Vue.prototype.$viewPortType = 'xs'
        }else{
            Vue.prototype.$viewPortType = 'rests'
        }
    }
// 初始化
    setRem();
    // 改变窗口大小时重新设置 rem
    window.onresize = function () {
        setRem()
    }

}


export {
    resize
} 



// WEBPACK FOOTER //
// ./src/utils/rem.js